import { createMuiTheme } from '@material-ui/core'

export const styleID = 'jss-server-side'

export const irisTheme = createMuiTheme({
  typography: {
    fontFamily: 'Px Grotesk',
    fontSize: '16px',
  },
  palette: {
    primary: {
      main: '#534DC9',
    },
  },
  overrides: {
    MuiFormHelperText: {
      root: {
        fontSize: '12px',
        color: 'blue',
      },
    },
    MuiFormControl: {
      root: {
        width: '100% !important',
      },
    },
    MuiInput: {
      underline: {
        '&:hover:not($disabled):not($error):not($focused):before': {
          borderBottomColor: '#727FE0',
        },
      },
    },
    MuiCircularProgress: {
      colorPrimary: {
        color: 'white',
      },
      colorSecondary: {
        color: 'black',
      },
    },
  },
  props: {
    MuiInput: {
      spellCheck: false,
    },
  },
})
